import React, { useContext, useEffect } from "react";
import { ReactComponent as Error404 } from "../../../img/404.svg";
import { StyledErrorContainer, StyledErrorTitle, StyledErrorP } from "./errorPage.style.js";

import FixelDataContext from "../../../context/FixelDataContext";

const ErrorPage = () => {
    const { setShowSpinner } = useContext(FixelDataContext);

    useEffect(() => {
        setShowSpinner(false);
    }, []);

    return (
        <StyledErrorContainer>
            <StyledErrorTitle>Oh, dear</StyledErrorTitle>
            <StyledErrorP>Something went wrong, we’re working on fixing it. </StyledErrorP>
            <StyledErrorP>
                If you’re still stuck, shoot us an email at{" "}
                <a rel="noreferrer" target="_blank" href="mailto:stores@fixel.ai">
                    stores@fixel.ai
                </a>
            </StyledErrorP>
            <Error404 />
        </StyledErrorContainer>
    );
};
export default ErrorPage;
